/* eslint-disable no-unused-vars */
import store from '../../store'
import Config from '../../Config'

export const vagasService = {
  VagasArea,
  VagasUltimas,
  VagasRelacionadas
}

function VagasArea(chave) {

  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    }
  };
  return fetch(`${Config.baseUrl}/VagasPorArea/${store.getters.getApiKey}`, requestOptions)
    .then(response => {
      if (response.status === 200) {
        return response.json();
      } else {
        const obj = {
          error: response.text()
        }
        return obj;
      }
    }).catch(
      error => {
        return { 'error': error }
      }
    );
}


function VagasUltimas(obj) {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    }
  };
  return fetch(`${Config.baseUrl}/VagasAbertas/${store.getters.getApiKey}?limit=${obj.perPage}&page=${obj.pageNum}&search=${obj.search}`, requestOptions)
    .then(response => {
      if (response.status === 200) {
        return response.json();
      } else {
        const obj = {
          error: response.text()
        }
        return obj;
      }
    }).catch(
      error => {
        return { 'error': error }
      }
    );
}

function VagasRelacionadas(vagas_id) {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    }
  };
  return fetch(`${Config.baseUrl}/VagasOutras/${vagas_id}?limit=3&page=1`, requestOptions)
    .then(response => {
      if (response.status === 200) {
        return response.json();
      } else {
        const obj = {
          error: response.text()
        }
        return obj;
      }
    }).catch(
      error => {
        return { 'error': error }
      }
    );

}



